import React from 'react';
import { connect } from 'react-redux';
import { RouterSelectors } from '@zapier/toolbox-redux-framework';
import { QueryClient, QueryClientProvider } from 'react-query';

import App from './App';

const queryClient = new QueryClient();

const mapStateToProps = state => {
  return { stepPath: RouterSelectors.getParam('step', state) };
};

function Container() {
  const CliGuide = connect(mapStateToProps)(App);

  return (
    <QueryClientProvider client={queryClient}>
      <CliGuide />
    </QueryClientProvider>
  );
}

export default Container;
